import React from 'react';
import CheckBoxInput from '../../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../../controls/selectInput.jsx';
import TextInput from '../../../../controls/textInput.jsx';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getCurrentUserId, getRoles, getCurrentUserCompanyId } from '../../../../services/userRights';
import { isUndefined } from 'util';

export default class PayerTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            initiators: [],
            subCompanies: [],
            shipmentTypes: [],
            shipmentPurposes: [],
            products: [],
            regions: [],
            costCenters: [],
            glAccounts: [],
            userCompanies: [],
            userCompanyInitiators: [],
            editVm: {
                isVisibleSubCompany: false,
                isVisibleShipmentType: false,
                isVisibleShipmentPurpose: false,
                isVisibleProduct: false,
                isVisibleRegion: false,
                isVisibleGlAccount: false,
                isVisibleCostCenter: false,
                isVisibleUserCompany: false,
                canEditInitiator: false,
                canEditCrossSector: false,
                canEditShipmentType: false,
                canEditShipmentPurpose: false,
                canEditProduct: false,
                canEditRegion: false,
                canEditCostCenter: false,
                canEditGlAccount: false,
                canEditUserCompany: false
            }
        };

        this.lastCrossSector = undefined;
        this.lastSubCompanyId = undefined;
        this.lastShipmentTypeId = undefined;
        this.lastShipmentPurposeId = undefined;
        this.lastProductId = undefined;
        this.lastInitiatorId = undefined;
        this.lastCostCenterId = undefined;
        this.isLoadingUserCompanies = false;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
        parcel.payerTabVisible = false;
        parcel.initiatorId = null;
        parcel.isCrossSector = false;
        parcel.subCompanyId = null;
        parcel.initiatorIsCrossSector = false;
        parcel.initiatorSubCompanyId = null;
        parcel.shipmentTypeId = null;
        parcel.shipmentPurposeId = null;
        parcel.productId = null;
        parcel.activityCode = "";
        parcel.regionId = null;
        parcel.regionCode = "";
        parcel.costCenterId = null;
        parcel.glAccountId = null;
        parcel.userCompanyId = null;
        return parcel;
    }

    reloadReferences() {
        console.log('payerTab: reloadReferences');
        this.updateBusyCount(1);
        let loadSubCompanies = apiGet('ref/subCompanies/list/' + this.props.parcel.companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.subCompanies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    if (!this.props.parcel.subCompanyId && prevState.subCompanies.length === 1) {
                        this.handleSelectionChange('subCompanyId', prevState.subCompanies[0]);
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let loadInitiators = Promise.resolve();
        let loadUserCompanies = Promise.resolve();

        //payerTabState
        this.updateBusyCount(1);
        let parcel = this.props.parcel;
        let stateRequest = {
            isCrossSector: parcel.isCrossSector,
            initiatorId: parcel.initiatorId,
            companyId: parcel.companyId,
            subCompanyId: parcel.subCompanyId,
            shipmentTypeId: parcel.shipmentTypeId,
            shipmentPurposeId: parcel.shipmentPurposeId
        };
        let loadControlStates = apiPost('parcels/payerTabState', stateRequest)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState({ editVm: data });

                let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
                let isOnlyBeforeSendEditable = this.props.isNew
                    || this.props.parcel.statusCode === "Created"
                    || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);

                this.props.parcel.payerTabVisible = data.isVisible && (this.props.parcel.userCompanyId != null || isOnlyBeforeSendEditable);

                if (data.isVisibleUserCompany && !this.isLoadingUserCompanies) {
                    loadUserCompanies = this.loadUserCompanies(parcel);
                } else { //если старая логика, где инициаторы не зависят от выбранного юр лица
                    loadInitiators = this.loadInitiators();
                }
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let loadOtherRefs = this.reloadReferencesWithDependences();

        return Promise.all([loadSubCompanies, loadInitiators, loadControlStates, loadUserCompanies, loadOtherRefs]);
    }

    reloadReferencesWithDependences() {
        let parcel = this.props.parcel;
        let loadShipmentTypes = Promise.resolve();
        let loadShipmentPurposes = Promise.resolve();
        let loadProducts = Promise.resolve();
        let loadRegions = Promise.resolve();
        let loadCostCenters = Promise.resolve();
        let loadGlAccounts = Promise.resolve();

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let shipmentTypesRequest = {
                isCrossSector: parcel.isCrossSector,
                subCompanyId: parcel.subCompanyId,
                companyId: parcel.companyId
            };
            loadShipmentTypes = apiPost('ref/shipmentTypes/list', shipmentTypesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        prevState.shipmentTypes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentTypeId) {
                                hasSelection = true;
                            }
                            let newEntry = { value: entry.id, label: entry.name };
                            if (entry.isDefault) {
                                defaultValue = newEntry;
                            }
                            return newEntry;
                        });
                        if ((parcel.shipmentTypeId === null || parcel.shipmentTypeId === undefined || !hasSelection) && defaultValue) {
                            this.handleSelectionChange('shipmentTypeId', defaultValue);
                        } else if (!isUndefined(parcel.shipmentTypeId)) {
                            if (prevState.shipmentTypes.length === 1) {
                                this.handleSelectionChange('shipmentTypeId', prevState.shipmentTypes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentTypeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId) {
            this.updateBusyCount(1);
            let shipmentPurposesRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId
            };
            loadShipmentPurposes = apiPost('ref/shipmentPurposes/list', shipmentPurposesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.shipmentPurposes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentPurposeId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name };
                        });
                        if (!isUndefined(parcel.shipmentPurposeId)) {
                            if (prevState.shipmentPurposes.length === 1) {
                                this.handleSelectionChange('shipmentPurposeId', prevState.shipmentPurposes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentPurposeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastCostCenterId !== parcel.costCenterId) {
            this.updateBusyCount(1);
            let regionsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                costCenterId: parcel.costCenterId
            };
            loadRegions = apiPost('ref/regions/list', regionsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.regions = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.regionId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name, code: entry.code };
                        });
                        if (!isUndefined(parcel.regionId)) {
                            if (prevState.regions.length === 1) {
                                this.handleSelectionChange('regionId', prevState.regions[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('regionId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            //|| this.lastShipmentPurposeId !== parcel.shipmentPurposeId
            || this.lastProductId !== parcel.productId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let costCentersRequest = {
                isCrossSector: parcel.isCrossSector,
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId,
                productId: parcel.productId,
                userId: parcel.initiatorId
            };
            loadCostCenters = apiPost('ref/costCenters/list', costCentersRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        prevState.costCenters = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.costCenterId) {
                                hasSelection = true;
                            }
                            let newValue = { value: entry.id, label: entry.name };
                            if (entry.isDefault) {
                                defaultValue = newValue;
                            }
                            return newValue;
                        });
                        if (defaultValue) {
                            this.handleSelectionChange('costCenterId', defaultValue);
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
            this.updateBusyCount(1);
            let glAccountsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadGlAccounts = apiPost('ref/glAccounts/list', glAccountsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.glAccounts = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.glAccountId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name, activityCode: entry.activityCode };
                        });
                        if (!isUndefined(parcel.glAccountId)) {
                            if (prevState.glAccounts.length === 1) {
                                this.handleSelectionChange('glAccountId', prevState.glAccounts[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('glAccountId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastShipmentPurposeId !== parcel.shipmentPurposeId) {

            this.updateBusyCount(1);
            let productsRequest = {
                companyId: parcel.companyId,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadProducts = apiPost('ref/products/list/', productsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        let defaultValue = null;
                        prevState.products = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.productId) {
                                hasSelection = true;
                            }
                            let newValue = { value: entry.id, label: entry.name, activityCode: entry.activityCode };
                            if (entry.isDefault) {
                                defaultValue = newValue;
                            }
                            return newValue;
                        });
                        if (defaultValue && parcel.productId !== defaultValue.value) {
                            this.handleSelectionChange('productId', defaultValue);
                        } else if (!isUndefined(parcel.productId)) {
                            if (prevState.products.length === 1) {
                                this.handleSelectionChange('productId', prevState.products[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('productId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        this.lastCrossSector = parcel.isCrossSector;
        this.lastSubCompanyId = parcel.subCompanyId;
        this.lastShipmentTypeId = parcel.shipmentTypeId;
        this.lastShipmentPurposeId = parcel.shipmentPurposeId;
        this.lastProductId = parcel.productId;
        this.lastInitiatorId = parcel.initiatorId;
        this.lastCostCenterId = parcel.costCenterId;

        return Promise.all([loadShipmentPurposes, loadShipmentTypes, loadProducts, loadRegions, loadCostCenters, loadGlAccounts]);
    }

    loadInitiators() {
        let currentUserId = getCurrentUserId();
        this.updateBusyCount(1);
        return apiGet('ref/users/initiators/' + this.props.parcel.companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.initiators = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (entry.id === currentUserId || entry.isDefault)) {
                            let fieldsChanges = [
                                {
                                    name: "initiatorId",
                                    value: entry.id
                                },
                                {
                                    name: "isCrossSector",
                                    value: entry.isCrossSector
                                },
                                {
                                    name: "subCompanyId",
                                    value: entry.subCompanyId
                                },
                                {
                                    name: "initiatorIsCrossSector",
                                    value: entry.isCrossSector
                                },
                                {
                                    name: "initiatorSubCompanyId",
                                    value: entry.subCompanyId
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges)
                                .then(() => {
                                    if (this.props.isNew) {
                                        this.reloadReferencesWithDependences();
                                    }
                                });
                        }
                        return {
                            value: entry.id,
                            label: entry.fullName,
                            subCompanyId: entry.subCompanyId,
                            isCrossSector: entry.isCrossSector
                        };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadUserCompanies(parcel) {
        this.isLoadingUserCompanies = true;
        this.updateBusyCount(1);
        let request = {
            userId: getCurrentUserId()
        }
        loadUserCompanies = apiPost('ref/usercompanies/list', request)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let hasSelection = false;
                    let currentUserCompanyId = getCurrentUserCompanyId();
                    prevState.userCompanies = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (currentUserCompanyId !== undefined && entry.companyId === currentUserCompanyId)) {
                            let fieldsChanges = [
                                {
                                    name: "userCompanyId",
                                    value: entry.companyId
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges);
                        }
                        if (entry.companyId === parcel.userCompanyId) {
                            hasSelection = true;
                        }
                        return { value: entry.companyId, label: entry.name };
                    });
                    if (!isUndefined(parcel.userCompanyId)) {
                        if (prevState.userCompanies.length > 0 && !hasSelection) {
                        } else if (!hasSelection) {
                            this.handleSelectionChange('userCompanyId', null);
                        }
                    }
                    this.loadInitiatorsByCompany(this.props.parcel.userCompanyId);
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
        return loadUserCompanies;
    }

    loadInitiatorsByCompany(companyId) {
        let currentUserId = getCurrentUserId();
        this.updateBusyCount(1);
        return apiGet('ref/users/initiators/' + companyId)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.userCompanyInitiators = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (entry.id === currentUserId || entry.isDefault)) {
                            let fieldsChanges = [
                                {
                                    name: "initiatorId",
                                    value: entry.id
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges)
                                .then(() => {
                                    if (this.props.isNew) {
                                        this.reloadReferencesWithDependences();
                                    }
                                });
                        }
                        return {
                            value: entry.id,
                            label: entry.fullName,
                        };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    fillModel(parcel) {
        parcel.initiatorId = this.props.parcel.initiatorId;
        parcel.isCrossSector = this.props.parcel.isCrossSector;
        parcel.subCompanyId = this.props.parcel.subCompanyId;
        parcel.shipmentTypeId = this.props.parcel.shipmentTypeId;
        parcel.shipmentPurposeId = this.props.parcel.shipmentPurposeId;
        parcel.productId = this.props.parcel.productId;
        parcel.regionId = this.props.parcel.regionId;
        parcel.costCenterId = this.props.parcel.costCenterId;
        parcel.glAccountId = this.props.parcel.glAccountId;
        parcel.userCompanyId = this.props.parcel.userCompanyId;
        return parcel;
    }

    isNextStepAvailable() {
        let errors = this.validateForm();
        if (errors === null)
            return true;
        return false;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors)
            && (errors.initiatorId
                || errors.subCompanyId
                || errors.shipmentTypeId
                || errors.shipmentPurposeId
                || errors.productId
                || errors.regionId
                || errors.costCenterId
                || errors.glAccountId
                || errors.userCompanyId);
    }

    validateForm(fieldName) {
        var result = null;

        if (!this.props.parcel.payerTabVisible)
            return null;

        if (isUndefined(fieldName) || fieldName === "initiatorId") {
            if (!this.props.parcel.initiatorId) {
                result = result ? result : {};
                result.initiatorId = "Инициатор является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleSubCompany && (isUndefined(fieldName) || fieldName === "subCompanyId")) {
            if (!this.props.parcel.subCompanyId) {
                result = result ? result : {};
                result.subCompanyId = "Сектор является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleShipmentType && (isUndefined(fieldName) || fieldName === "shipmentTypeId")) {
            if (!this.props.parcel.shipmentTypeId) {
                result = result ? result : {};
                result.shipmentTypeId = "Тип отправки является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleCostCenter && (isUndefined(fieldName) || fieldName === "costCenterId")) {
            if (!this.props.parcel.costCenterId) {
                result = result ? result : {};
                result.costCenterId = "Кост-центр является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleGlAccount && (isUndefined(fieldName) || fieldName === "glAccountId")) {
            if (!this.props.parcel.glAccountId) {
                result = result ? result : {};
                result.glAccountId = "GL аккаунт является обязательным полем";
            }
        }

        if (this.state.editVm.isVisibleUserCompany && (isUndefined(fieldName) || fieldName === "userCompanyId")) {
            if (!this.props.parcel.userCompanyId) {
                result = result ? result : {};
                result.userCompanyId = "Юр лицо является обязательным полем";
            }
        }
        return result;
    }

    getFieldsChanges(name, selection, isSelection) {
        let newValue = isSelection ? (selection ? selection.value : null) : selection;
        let fieldsChanges = [
            {
                name: name,
                value: newValue
            }
        ];

        if (name === 'userCompanyId') {
            fieldsChanges.push({
                name: 'initiatorId',
                value: null
            });
        }

        if (name === 'initiatorId') {
            fieldsChanges.push({
                name: 'isCrossSector',
                value: selection ? selection.isCrossSector : false
            });
            if (selection) {
                fieldsChanges.push({
                    name: 'subCompanyId',
                    value: selection.subCompanyId
                });
            }
            fieldsChanges.push({
                name: 'initiatorIsCrossSector',
                value: selection ? selection.isCrossSector : false
            });
            fieldsChanges.push({
                name: 'initiatorSubCompanyId',
                value: selection ? selection.subCompanyId : null
            });
        } else if (name === 'regionId') {
            fieldsChanges.push({
                name: 'regionCode',
                value: selection ? selection.code : ""
            });
        } else if (name === 'productId') {
            fieldsChanges.push({
                name: 'activityCode',
                value: selection ? selection.activityCode : ""
            });
        } else if (name === 'isCrossSector' && !newValue) {
            fieldsChanges.push({
                name: 'subCompanyId',
                value: this.props.parcel.initiatorSubCompanyId
            });
        }

        return fieldsChanges;
    }

    handleSelectionChange(name, selection, ignoreValidation) {
        let newValue = selection ? selection.value : null;
        let fieldsChanges = this.getFieldsChanges(name, selection, true);
        return this.props.onFieldChange(fieldsChanges)
            .then(() => {
                this.handleFieldEdited(name, newValue);
                if (this.props.isNew) {
                    this.reloadReferencesWithDependences();
                }
            });
    }

    handleInputEdited(name, value) {
        let fieldsChanges = this.getFieldsChanges(name, value, false);
        this.props.onFieldChange(fieldsChanges)
            .then(() => {
                this.handleFieldEdited(name, value);
                if (this.props.isNew && name === "isCrossSector") {
                    this.reloadReferencesWithDependences();
                }
            });
    }

    handleFieldEdited(name, value, ignoreValidation) {
        if (this.props.onFieldEdited) {
            this.props.onFieldEdited(name, value, ignoreValidation);
        }
    }

    handleUserCompanyEdited(e) {
        this.handleSelectionChange("userCompanyId", e)
            .then(data => {
                this.handleFieldEdited("initiatorId", null, true);
                this.loadInitiatorsByCompany(this.props.parcel.userCompanyId);
            });
    }

    renderShipmentType(isVisible, isBusy, isOnlyBeforeSendEditable) {
        if (isVisible) {
            return (
                <div className={"form-group" + (this.props.errors.shipmentTypeId ? " has-error" : "")}>
                    <label htmlFor="selectShipmentType">Тип отправки<span className="text-red">*</span></label>
                    <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Тип отправки"
                        data-content="">
                        <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                    </a>
                    <SelectInput id="selectShipmentType"
                        clearable={false}
                        options={this.state.shipmentTypes}
                        value={this.props.parcel.shipmentTypeId}
                        title={this.props.errors.shipmentTypeId}
                        onChange={e => this.handleSelectionChange("shipmentTypeId", e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentType}
                    />
                </div>);
        }
        return null;
    }

    renderShipmentPurpose(isVisible, isBusy, isOnlyBeforeSendEditable) {
        if (isVisible) {
            return (
                <div className={"form-group" + (this.props.errors.shipmentPurposeId ? " has-error" : "")}>
                    <label htmlFor="selectShipmentPurposeId">Тип/цель отправки</label>
                    <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Цель отправки"
                        data-content="">
                        <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                    </a>
                    <SelectInput id="selectShipmentPurposeId"
                        clearable={false}
                        options={this.state.shipmentPurposes}
                        value={this.props.parcel.shipmentPurposeId}
                        title={this.props.errors.shipmentPurposeId}
                        onChange={e => this.handleSelectionChange("shipmentPurposeId", e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentPurpose}
                    />
                </div>);
        }
        return null;
    }

    renderCostCenter(isVisible, isBusy) {
        if (isVisible) {
            return (
                <div className={"form-group" + (this.props.errors.costCenterId ? " has-error" : "")}>
                    <label htmlFor="selectCostCenter">Кост центр<span className="text-red">*</span></label>
                    <SelectInput id="selectCostCenter"
                        clearable={false}
                        options={this.state.costCenters}
                        value={this.props.parcel.costCenterId}
                        title={this.props.errors.costCenterId}
                        onChange={e => this.handleSelectionChange("costCenterId", e)}
                        disabled={isBusy || !this.state.editVm.canEditCostCenter}
                    />
                </div>
            );
        }
        return null;
    }

    renderGlAccount(isVisible, isBusy) {
        if (isVisible) {
            return (
                <div className={"form-group" + (this.props.errors.glAccountId ? " has-error" : "")}>
                    <label htmlFor="selectGlAccountId">GL аккаунт<span className="text-red">*</span></label>
                    <SelectInput id="selectGlAccountId"
                        clearable={false}
                        options={this.state.glAccounts}
                        value={this.props.parcel.glAccountId}
                        title={this.props.errors.glAccountId}
                        onChange={e => this.handleSelectionChange("glAccountId", e)}
                        disabled={isBusy || !this.state.editVm.canEditGlAccount}
                    />
                </div>
            );
        }
        return null;
    }

    renderRegion(isVisible, isBusy) {
        if (isVisible) {
            return (
                <div>
                    <div className={"form-group" + (this.props.errors.regionId ? " has-error" : "")}>
                        <label htmlFor="selectRegionId">Регион</label>
                        <SelectInput id="selectRegionId"
                            clearable={false}
                            options={this.state.regions}
                            value={this.props.parcel.regionId}
                            title={this.props.errors.regionId}
                            onChange={e => this.handleSelectionChange("regionId", e)}
                            disabled={isBusy || !this.state.editVm.canEditRegion}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputRegionCode">Код региона</label>
                        <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Код региона"
                            data-content="Код региона - финансовый код региона">
                            <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                        </a>
                        <TextInput id="inputRegionCode" value={this.props.parcel.regionCode} disabled />
                    </div>
                </div>

            );
        }
        return null;
    }

    renderProduct(isVisible, isBusy) {
        if (isVisible) {
            return (
                <div>
                    <div className={"form-group" + (this.props.errors.productId ? " has-error" : "")}>
                        <label htmlFor="selectProductId">Клиент/продукт</label>
                        <SelectInput id="selectProductId"
                            clearable={false}
                            options={this.state.products}
                            value={this.props.parcel.productId}
                            title={this.props.errors.productId}
                            onChange={e => this.handleSelectionChange("productId", e)}
                            disabled={isBusy || !this.state.editVm.canEditProduct}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputActivityCode">Активити код</label>
                        <TextInput id="inputActivityCode" value={this.props.parcel.activityCode} disabled />
                    </div>
                </div>
            );
        }
        return null;
    }

    renderUserCompany(isVisible, isBusy, isOnlyBeforeSendEditable) {
        if (isVisible) {
            return (
                <div className={"form-group" + (this.props.errors.userCompanyId ? " has-error" : "")}>
                    <label htmlFor="selectUserCompanyId">Юр лицо<span className="text-red">*</span></label>
                    <SelectInput id="selectUserCompanyId"
                        clearable={false}
                        options={this.state.userCompanies}
                        value={this.props.parcel.userCompanyId}
                        title={this.props.errors.userCompanyId}
                        onChange={e => this.handleUserCompanyEdited(e)}
                        disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditUserCompany}
                    />
                </div>
            );
        }

        return null;
    }

    renderInitiator(isBusy, isOnlyBeforeSendEditable, isVisibleCrossSector) {
        return (
            <div className={"form-group" + (this.props.errors.initiatorId ? " has-error" : "")}>
                <label htmlFor="selectInitiator">Инициатор<span className="text-red">*</span></label>
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Инициатор "
                    data-content="Инициатор - это тот, кто платит за отправку ">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
                <SelectInput id="selectInitiator"
                    clearable={false}
                    options={this.state.initiators}
                    value={this.props.parcel.initiatorId}
                    title={this.props.errors.initiatorId}
                    onChange={e => this.handleSelectionChange("initiatorId", e)}
                    disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator}
                />

                {isVisibleCrossSector ? (
                    <div className="checkbox">
                        <label>
                            <CheckBoxInput id="inputIsCrossSector"
                                checked={this.props.parcel.isCrossSector}
                                onChange={e => this.handleInputEdited("isCrossSector", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || this.props.parcel.initiatorIsCrossSector || !this.state.editVm.canEditCrossSector} />
                                    Кросс-функция
                                </label>
                        <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Кросс-функция"
                            data-content="Выберите, только если вы кросс-секторальный сотрудник и отправка для целей определенного сектора">
                            <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                        </a>
                    </div>
                ) : null}
            </div>
        );
    }

    renderInitiatorByUserCompanies(isBusy, isOnlyBeforeSendEditable) {
        return (
            <div className={"form-group" + (this.props.errors.initiatorId ? " has-error" : "")}>
                <label htmlFor="selectInitiator">Инициатор<span className="text-red">*</span></label>
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Инициатор "
                    data-content="Инициатор - это тот, кто платит за отправку ">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
                <SelectInput id="selectInitiator"
                    clearable={false}
                    options={this.state.userCompanyInitiators}
                    value={this.props.parcel.initiatorId}
                    title={this.props.errors.initiatorId}
                    onChange={e => this.handleSelectionChange("initiatorId", e)}
                    disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator}
                />
            </div>
        );
    }

    render() {
        let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isOnlyBeforeSendEditable = this.props.isNew
            || this.props.parcel.statusCode === "Created"
            || (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isBusy = this.props.isBusy || this.state.busyCount > 0;
        if (this.state.editVm.isVisibleUserCompany)
            return (
                <div className="row">
                    <div className="col-sm-6">
                        {this.renderUserCompany(true, isBusy, isOnlyBeforeSendEditable)}
                    </div>
                    <div className="col-sm-6">
                        {this.renderInitiatorByUserCompanies(isBusy, isOnlyBeforeSendEditable)}
                    </div>
                </div>
            );
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">Инициатор отправки</h4>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        {this.renderInitiator(isBusy, isOnlyBeforeSendEditable, true)}
                    </div>
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.subCompanyId ? " has-error" : "")}>
                            <label htmlFor="selectSubCompany">Сектор<span className="text-red">*</span></label>
                            <SelectInput id="selectSubCompany"
                                clearable={false}
                                options={this.state.subCompanies}
                                value={this.props.parcel.subCompanyId}
                                title={this.props.errors.subCompanyId}
                                onChange={e => this.handleSelectionChange("subCompanyId", e)}
                                disabled={isBusy || !this.props.parcel.isCrossSector || !isOnlyBeforeSendEditable}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">Инициатор отправки</h4>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        {this.renderShipmentType(this.state.editVm.isVisibleShipmentType, isBusy, isOnlyBeforeSendEditable)}
                        {this.renderShipmentPurpose(this.state.editVm.isVisibleShipmentPurpose, isBusy, isOnlyBeforeSendEditable)}
                        {this.renderRegion(this.state.editVm.isVisibleRegion, isBusy)}
                    </div>
                    <div className="col-sm-6">
                        {this.renderProduct(this.state.editVm.isVisibleProduct, isBusy)}
                        {this.renderCostCenter(this.state.editVm.isVisibleCostCenter, isBusy)}
                        {this.renderGlAccount(this.state.editVm.isVisibleGlAccount, isBusy)}
                    </div>
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/payerTab.jsx